<div
  class="snackbar"
  style="--background-color: {{ snackbar.color }}"
  *ngFor="let snackbar of snackbarService.snackbars"
  [@fadeInOut]
  (mouseenter)="onMouseEnter(snackbar)"
  (mouseleave)="onMouseLeave(snackbar)"
>
  <div class="message" [title]="snackbar.message">{{ trimStringPipe.transform(snackbar.message, 180) }}</div>
  <ng-container>
    <button
      *ngFor="let action of snackbar.actions; let i = index; let l = last; let f = first"
      class="btn btn-primary btn-md action"
      [class]="{ 'btn-ghost': !l, 'last': l, 'first': f }"
      (click)="snackbarService.performAction(snackbar, action)"
    >
      <i *ngIf="action.icon" [class]="action.icon"></i>
      {{ action.label }}
    </button>
  </ng-container>
  <div class="close close-icon" (click)="onCloseClick(snackbar)"></div>
</div>
